<template>
  <div v-if="cashoutMethod">
    <cashout-method-details
      :data-cashout-method.sync="cashoutMethod"
      @update:dataCashoutMethod="updatecashoutMethod"
    />
    <transaction-fees
      class="mt-3"
      hasReceivingCountry
      :fees_url="`/api/v1/transactions/transferCashoutMethod/${cashoutMethod.id}/fees`"
    />
  </div>
</template>

<script>
import TransactionFees from "../fees";
import CashoutMethodDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    TransactionFees,
    CashoutMethodDetails,
  },
  data: () => ({
    cashoutMethod: null,
  }),
  mounted() {
    this.fetchcashoutMethod();
  },
  watch: {
    id() {
      this.fetchcashoutMethod();
    },
  },
  methods: {
    fetchcashoutMethod() {
      this.$http
        .get(`/api/v1/transactions/transferCashoutMethods/${this.id}`)
        .then((cashoutMethod) => (this.cashoutMethod = cashoutMethod));
    },
    updatecashoutMethod(cashoutMethod) {
      if (cashoutMethod) {
        this.cashoutMethod = cashoutMethod;
      }
    },
  },
};
</script>

<style></style>
